import React from "react"
import ReactDOM from "react-dom"
import { StartPageApp } from "@cirrus/common/StartPage"

// Render React component - works whether DOM is ready or not
const render = () => {
  ReactDOM.render(<StartPageApp />, document.getElementById("content-region"))
}

// If DOM still loading, wait for it; otherwise render immediately
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', render)
} else {
  render()
}
